import { Checkbox as AntCheckbox, CheckboxProps } from "antd";

export type { CheckboxProps };
export default function Checkbox(props: CheckboxProps) {
  return <AntCheckbox {...props} />;
}

Checkbox.Group = AntCheckbox.Group;
